import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PublicShare = () => {
  const { shareId } = useParams();
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  
  // Dynamic API URL configuration - same as in App.js
  const isProduction = process.env.NODE_ENV === 'production' || 
                      window.location.hostname !== 'localhost';
  
  const api = isProduction 
    ? window.location.origin  // Use current domain in production (Railway)
    : "http://localhost:8000"; // Use localhost in development

  useEffect(() => {
    const initializePublicSession = async () => {
      try {
        console.log('PublicShare: Initializing with shareId:', shareId);
        console.log('PublicShare: API URL:', api);
        const response = await fetch(`${api}/public_session/${shareId}`);
        
        if (!response.ok) {
          console.error('PublicShare: Response not OK:', response.status, response.statusText);
          if (response.status === 404) {
            setError('Share link not found');
          } else if (response.status === 410) {
            setError('Share link has expired or been deactivated');
          } else {
            setError(`Failed to load shared session (${response.status})`);
          }
          return;
        }
        
        const data = await response.json();
        setSessionData(data);
        setSessionId(data.session_id);
        
        // Store shared preferences in sessionStorage for the main app
        if (data.shared_preferences) {
          sessionStorage.setItem('publicSharePreferences', JSON.stringify(data.shared_preferences));
        }
        
        // Initialize the app with public session data on /app route
        window.location.href = `/app?shareId=${shareId}&sessionId=${data.session_id}&isPublic=true`;
        
      } catch (err) {
        setError('Failed to connect to server');
      } finally {
        setLoading(false);
      }
    };

    if (shareId) {
      initializePublicSession();
    }
  }, [shareId, api]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#000',
        color: 'white'
      }}>
        <div style={{
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: 20,
            marginBottom: 10
          }}>Loading shared Legacy mode...</div>
          <div style={{
            fontSize: 14,
            opacity: 0.7
          }}>Connecting to shared session</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#000',
        color: 'white'
      }}>
        <div style={{
          textAlign: 'center',
          padding: 20
        }}>
          <div style={{
            fontSize: 24,
            marginBottom: 10,
            color: '#ff6b6b'
          }}>⚠️ {error}</div>
          <div style={{
            fontSize: 14,
            opacity: 0.7,
            marginBottom: 20
          }}>This shared link may have expired or been removed.</div>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              backgroundColor: '#3b725f',
              color: 'white',
              fontSize: 16,
              cursor: 'pointer'
            }}
          >
            Go to Main App
          </button>
        </div>
      </div>
    );
  }

  return null; // This will redirect to the main app
};

export default PublicShare; 